// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".A8qtw {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\n\n._3PCZ2 {\n  padding: unset;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n\n.tpAnW {\n  padding: var(--space-100) !important;\n  border-radius: var(--radius-75);\n}\n\n.tpAnW:hover {\n    background-color: var(--surface-brand-hover);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": "A8qtw",
	"paper": "_3PCZ2",
	"anchorButton": "tpAnW"
};
export default ___CSS_LOADER_EXPORT___;
